import { Autocomplete, TextField, OutlinedTextFieldProps } from "@mui/material";
import { useProducts } from "Hooks/useProducts";
import { useMemo } from "react";

export interface IProductBrandsDropdownProps
  extends Omit<OutlinedTextFieldProps, "onChange"> {
  value?: string;
  onChange: (c?: string) => void;
  disableClearable?: boolean;
}

function ProductBrandsDropdown({
  label,
  size,
  variant,
  value,
  onChange,
  fullWidth,
  sx,
  disableClearable,
}: IProductBrandsDropdownProps) {
  const { products } = useProducts();

  const brands = useMemo(
    () => Array.from([...new Set(products.map((p) => p.brand || ""))]),
    [products]
  );

  const selected = useMemo(
    () => (brands || []).find((l) => l === value) || "",
    [brands, value]
  );
  return (
    <Autocomplete
      sx={sx}
      fullWidth={fullWidth}
      options={[...brands].sort((a, b) => (a || "").localeCompare(b || ""))}
      value={selected}
      onChange={(e, v) => {
        onChange(v || "");
      }}
      disableClearable={disableClearable}
      getOptionLabel={(o: string) => o || ""}
      renderInput={(params) => (
        <TextField {...params} label={label} variant={variant} size={size} />
      )}
    />
  );
}

export default ProductBrandsDropdown;
